/**
 * AVVISO ROSSO SOTTO IL TESTO DEL RETRO (Týpos, 16 ott 2026). Davide: «quando arrivo al limite che non posso scrivere piu'
 * niente fallo presente al cliente con un alert rosso».
 *
 * Due casi:
 *  - il cliente ha scritto il numero massimo di caratteri della casella (definition.max del parametro "Incisione"):
 *    la casella non accetta altro;
 *  - il testo e' piu' lungo di quello che sta sul gioiello (lettere sotto 1,2 mm): lo dice il modello nella scheda
 *    (uscita dati "Scheda" -> retro.troppo_lungo), e il testo non viene inciso.
 * L'avviso e' un riquadro rosso subito sotto la casella del testo. Come EidosDirittiFoto questo componente sta FUORI dal
 * MantineProvider: solo HTML semplice, la casella si ritrova nella pagina con un osservatore.
 */
import {useShapeDiverStoreParameters} from "@AppBuilderLib/entities/parameter/model/useShapeDiverStoreParameters";
import {useShapeDiverStoreSession} from "@AppBuilderLib/entities/session/model/useShapeDiverStoreSession";
import {IShapeDiverParameter} from "@AppBuilderLib/entities/parameter/config/parameter";
import {useEffect, useState} from "react";

const NOME_TESTO = "Incisione";
const NOME_DEDICA = "Dedica";
const MSG_MASSIMO = "Hai raggiunto il numero massimo di caratteri: non puoi scrivere altro.";
const MSG_LUNGO =
	"Il testo è troppo lungo per questo gioiello: le lettere diventerebbero più piccole di 1,2 mm e non si leggerebbero. Accorcialo un po' per poterlo incidere.";

/** retro.troppo_lungo dall'ultima scheda del modello */
function testoTroppoLungo(): boolean {
	try {
		const {sessions} = useShapeDiverStoreSession.getState();
		for (const s of Object.values(sessions)) {
			const outputs = (s as unknown as {outputs?: Record<string, {name?: string; content?: {data?: unknown}[]}>}).outputs ?? {};
			for (const o of Object.values(outputs)) {
				if (o.name !== "Scheda") continue;
				const d = o.content?.[0]?.data;
				const j = (typeof d === "string" ? JSON.parse(d) : d) as {retro?: {troppo_lungo?: boolean}} | null;
				return !!j?.retro?.troppo_lungo;
			}
		}
	} catch {
		/* ignora */
	}
	return false;
}

export default function EidosAvvisoRetro() {
	const parameterStores = useShapeDiverStoreParameters((s) => s.parameterStores);
	const namespaces = Object.keys(parameterStores);
	const [stato, setStato] = useState<{max: number; lunghezza: number; dedica: boolean; lungo: boolean}>({max: 0, lunghezza: 0, dedica: false, lungo: false});

	// testo, massimo di caratteri e "Dedica" dal modello; "troppo lungo" dalla scheda (riletta ogni mezzo secondo)
	useEffect(() => {
		const {getParameter} = useShapeDiverStoreParameters.getState();
		const testo = namespaces.map((ns) => getParameter(ns, NOME_TESTO)).find(Boolean);
		const dedica = namespaces.map((ns) => getParameter(ns, NOME_DEDICA)).find(Boolean);
		if (!testo) return;
		const leggi = () => {
			const p = testo.getState() as IShapeDiverParameter<string>;
			const v = String(p.state.uiValue ?? "");
			const max = Number((p.definition as {max?: number}).max) || 0;
			const d = dedica ? String((dedica.getState() as IShapeDiverParameter<string>).state.uiValue ?? "") !== "0" : true;
			const lungo = testoTroppoLungo();
			setStato((s) => (s.max === max && s.lunghezza === v.length && s.dedica === d && s.lungo === lungo ? s : {max, lunghezza: v.length, dedica: d, lungo}));
		};
		leggi();
		const a = testo.subscribe(leggi);
		const b = dedica ? dedica.subscribe(leggi) : () => undefined;
		const t = window.setInterval(leggi, 500);
		return () => {
			a();
			b();
			window.clearInterval(t);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [namespaces.join("|")]);

	const messaggio = !stato.dedica || stato.lunghezza === 0 ? "" : stato.max > 0 && stato.lunghezza >= stato.max ? MSG_MASSIMO : stato.lungo ? MSG_LUNGO : "";

	// il riquadro rosso subito sotto la casella del testo (la casella e' quella con il massimo di caratteri del modello)
	useEffect(() => {
		if (!stato.max) return;
		let vivo = true;
		let el: HTMLDivElement | null = null;
		const sistema = () => {
			const campo = [...document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>("input, textarea")].find(
				(i) => i.maxLength === stato.max && (i.type === "text" || i.tagName === "TEXTAREA"),
			);
			if (!campo) return;
			const contenitore = (campo.closest(".mantine-InputWrapper-root") as HTMLElement | null) ?? campo.parentElement;
			if (!contenitore || !contenitore.parentElement) return;
			if (!messaggio) {
				el?.remove();
				return;
			}
			if (!el) {
				el = document.createElement("div");
				el.className = "eidos-avviso-rosso";
				el.setAttribute("role", "alert");
			}
			el.textContent = messaggio;
			if (contenitore.nextElementSibling !== el) contenitore.insertAdjacentElement("afterend", el);
		};
		sistema();
		let attesa: number | undefined;
		const oss = new MutationObserver(() => {
			if (attesa !== undefined) return;
			attesa = window.setTimeout(() => {
				attesa = undefined;
				if (vivo) sistema();
			}, 150);
		});
		oss.observe(document.body, {childList: true, subtree: true});
		return () => {
			vivo = false;
			oss.disconnect();
			if (attesa !== undefined) window.clearTimeout(attesa);
			el?.remove();
		};
	}, [messaggio, stato.max]);

	return null;
}
